import { render } from "./Milestone.vue?vue&type=template&id=4316055e&scoped=true&ts=true"
import script from "./Milestone.ts?vue&type=script&lang=ts"
export * from "./Milestone.ts?vue&type=script&lang=ts"

import "./Milestone.scss?vue&type=style&index=0&id=4316055e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4316055e"]])

export default __exports__